import type { ToolOption } from "@/types/explore"

export const TOOLS: ToolOption[] = [
  { id: "distance", label: "Distance" },
  { id: "surface", label: "Aire" },
  { id: "altitude", label: "Elevation" },
  { id: "etude", label: "Etude" },
  { id: "compass", label: "Nord" },
]
